import React from "react";
import '../App.css';
import { connect } from "react-redux";
import { getMDDeatil, getOthersMI, getMDRelatedDocuments, getEuMI, getMDRemarks } from "../Actions/MDDetailAPI";
import { deleteMD } from "../Actions/MDDeleteAPI";
import { DownloadAttachment } from '../Actions/AttachmentAPI';
import Moment from 'moment';
import swal from "sweetalert"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { css } from "glamor";
toast.configure();
class MDDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: ""
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { match, dispatch } = nextProps;
        const { params } = match;
        const { id } = params;
        let updatedState = {};
        if (id !== prevState.id) {
            prevState.id = id;
            updatedState.id = id;
            dispatch(getMDDeatil(id));
            dispatch(getOthersMI(id));
            dispatch(getEuMI(id));
            dispatch(getMDRelatedDocuments(id));
            dispatch(getMDRemarks(id));
        }

        return updatedState;
    }

    ShowSidePanel = () => {
        this.props.dispatch({ type: 'ShowSidePan', data: false });
        this.props.history.push("/Home");
    }

    MDNewitemNav = () => {
        this.props.dispatch({ type: 'MD Library', data: false });
        this.props.dispatch({ type: 'Otherpages' });
        this.props.history.push("/Home/MDNewItem");
    }

    render() {
        const {
            mdDetailList, MIOthersList, MIEuList, RemarksList
        } = this.props;
        return (
            <div className="row">
                <div className="full-height">
                    <div className="row mr-3" style={{ height: "50px" }}>
                        <div className="ml-auto m-3 nav-item-link" onClick={this.MDNewitemNav}>New Item</div>
                    </div>
                    <div className="grey-bg  course-list-page pt-3">
                        <div className="p-4">
                            <div className="panel-box  search-filter-box mb-4">
                                <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" onClick={() => this.ShowSidePanel()}>&larr; Return</button>

                                <div className="resource-list-auth-date">
                                    <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                        <div className="card-body"><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>MD Declaration</h5></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Date of Declaration: </strong><i aria-hidden="true"></i><span className="italicFont "> {Moment(new Date(Date.parse(mdDetailList.dateOfDeclaration))).format('YYYY-MM-DD')}</span></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>MD ID No: </strong><em><span className="italicFont "> {mdDetailList.mdidNo}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Remark1: </strong><em><span className="italicFont "> {(RemarksList !== undefined && RemarksList.length !== 0) ? RemarksList[0].remarks : ''}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Remark2: </strong><em><span className="italicFont "> {(RemarksList !== undefined && RemarksList.length !== 0) ? RemarksList[1].remarks : ''}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Remark3: </strong><em><span className="italicFont "> {(RemarksList !== undefined && RemarksList.length !== 0) ? RemarksList[2].remarks : ''}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Company Name: </strong><em><span className="italicFont "> {mdDetailList.companyName}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Division name: </strong><em> <span className="italicFont "> {mdDetailList.divisionName}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Address: </strong><em><span className="italicFont "> {mdDetailList.address}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Contact Person: </strong><em> <span className="italicFont "> {mdDetailList.contactPerson}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Telephone Number: </strong><em><span className="italicFont "> {mdDetailList.telephone}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Fax No: </strong><em> <span className="italicFont "> {mdDetailList.fax}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Email: </strong><em>  <span className="italicFont "> {mdDetailList.email}</span></em></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>SDoC ID No: </strong><em>  <span className="italicFont "> {mdDetailList.sdocIdNo}&nbsp;&nbsp;</span>  <i className="fa fa-paperclip fa-lg click" style={{ width: 20 }} onClick={() => this.downloadAttachment(mdDetailList.mdAttachment[0].attachmentName, mdDetailList.mdAttachment[0].attachmentGuid)}></i></em></span>
                                        </div>
                                    </div>
                                    <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                        <div className="card-body"><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Product Information</h5></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Product Name: </strong><i aria-hidden="true"></i><span className="italicFont ">{mdDetailList.productName}</span></span>
                                        </div>
                                        <div className="col-sm-6 mb-2">

                                            <span><strong>Deliver Amount </strong></span>
                                            <div className="row">
                                                <div className="col-sm-6 mb-2">
                                                    <span><strong>Unit: </strong><em><span className="italicFont ">{mdDetailList.productMetricUnit}</span></em></span>
                                                </div>
                                                <div className="col-sm-6 mb-2">
                                                    <span><strong>Amount: </strong><em><span className="italicFont ">{mdDetailList.productQuantityAmount}</span></em></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Product Number: </strong><em> <span className="italicFont ">{mdDetailList.productNumber}</span></em></span>
                                        </div>

                                        <div className="col-sm-6 mb-2">
                                            <span><strong>Product Information: </strong><em> <span className="italicFont ">{mdDetailList.productInfo}</span></em></span>
                                        </div>
                                    </div>

                                    <div className="card mt-2" style={{ backgroundColor: "white" }}>
                                        <div className="card-body"><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Materials Information</h5></div>
                                    </div>
                                    <h6 className="mb-2 basic-font">This materials information shows the amount of hazardous materials contained in <span className="italicFont "> {mdDetailList.materialQuantityAmount}</span> {mdDetailList.materialMetricUnit} of product</h6>
                                    {MIOthersList && MIOthersList.length ? this.renderMIData(MIOthersList) : null}


                                    <h6 className="mb-2 basic-font">Below information is required for the EU Regulation on ship recycling</h6>
                                    {MIEuList && MIEuList.length ? this.renderMIData(MIEuList) : null}

                                    <h6 className="mb-2 basic-font">*Not applicable for ships flying the flag of a third country</h6>
                                    <h6 className="mb-2 basic-font">Concentrations of PFOS above 10 mg/kg (0.001% by weight) when it occurs in substances or in preparations or concentrations of PFOS in semi-finished products or articles, or parts thereof equal to or above than 0.1% by weight calculated with reference to the mass of structurally or micro-structurally distinct parts that contain PFOS or for textiles or other coated materials, if the amount of PFOS is equal to or above than 1ug/m of the coated material.</h6>
                                    <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                        <div className="card-body"><h5 className="card-title  ml-2 mt-2" style={{ color: "092a51" }}>MD Related Documents</h5></div>
                                    </div>
                                    {this.renderRDData()}
                                    <div className="col-lg-12 mt-2">
                                        <div className="form-group search-btn-col" style={{ textAlign: 'center' }}>
                                            <button className="btn btn-success text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.ShowEditScreen()}> Edit </button>

                                            <button className="btn btn-danger text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.DeleteItem()}> Delete </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div >

                </div >
            </div>
        )

    }
    renderMIData = (data) => {
        return data && data.length
            ? data.map((item, index) => {
                return (<div className="card MM-card-content" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                    {!item.isContainAboveThreshold ? <div className="arrow-right-green"></div> : <div className="arrow-right-red"></div>}
                    <div className="p-3">
                        <div className="resource-list-auth-date">
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <span><strong>Table: </strong><span className="italicFont ">{item.tableValue}</span></span>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <span><strong>Material Name: </strong><span className="italicFont "> {item.materialName}</span></span>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <span><strong>Threshold Value: </strong><span className="italicFont "> {item.thresholdValue}</span></span>
                                </div>
                            </div>
                            {item.isContainAboveThreshold ?
                                <div className="row">
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Mass: </strong><span className="italicFont "> {item.mass}</span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Unit: </strong><span className="italicFont ">{item.unit} </span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Information on where it is Used: </strong><span className="italicFont ">{item.informationOnUsage} </span></span>
                                    </div></div> : null}
                        </div>
                    </div>
                </div>);
            }) : null;
    }
    renderRDData = () => {
        const { RDList } = this.props;
        return RDList && RDList.length
            ? RDList.map((item, index) => {
                return (
                    <div className="card MM-card-content" style={{ backgroundColor: "#f0f0f0" }}>
                        <div className="p-3">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Title:</strong><span className="italicFont ">{item.attachmentName}&nbsp;&nbsp;<i className="fa fa-paperclip fa-lg click" style={{ width: 20 }} onClick={() => this.downloadAttachment(item.attachmentName, item.attachmentGuid)}></i></span></span>

                                    </div>
                                    <div className="col-sm-6 mb-2">
                                        <span><strong>Remarks: </strong><span className="italicFont ">{item.remarks}</span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Date of Preparation: </strong><span className="italicFont ">{item.dateOfDeclaration}</span></span>
                                    </div>
                                    <div className="col-sm-6">
                                        <span><strong>Document Creation Organization: </strong><span className="italicFont "> {item.documentCreationOrganization}</span></span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null
    }
    ShowEditScreen = () => {
        this.props.history.push(`/Home/MDEdit/${this.state.id}`);
        this.props.dispatch({ type: 'ShowMISidePan', data: false });
        this.props.dispatch({ type: 'ShowEURegSidePan', data: false });
        this.props.dispatch({ type: 'ShowRDSidePan', data: false });
        this.props.dispatch({ type: 'ShowSidePan', data: false });
        this.props.dispatch({ type: 'Otherpages' });
    }
    DeleteItem = () => {
        const { dispatch } = this.props;
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this record!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    toast("MD Item Deleted Successfully", {
                        className: css({
                            background: "#eee !important",
                            color: "black !important",
                            fontWeight: "bold"
                        }),
                        closeOnClick: false,
                        autoClose: 2000,
                        closeButton: false,
                        position: toast.POSITION.BOTTOM_CENTER,
                        hideProgressBar: true
                    })
                    dispatch(deleteMD(this.state.id));
                    this.props.history.push("/Home")
                } else {
                }
            });
    }
    downloadAttachment(fileName, guid) {
        const { dispatch } = this.props;
        let data = {};
        data.attachmentName = fileName;
        data.attachmentGuid = guid;
        dispatch(DownloadAttachment(data));
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        mdDetailList: (state.SidePanReducer.mdDetailList) ? state.SidePanReducer.mdDetailList : '',
        MIOthersList: state.SidePanReducer.MIOthersList,
        MIEuList: state.SidePanReducer.MIEuList,
        RDList: state.SidePanReducer.RDList,
        RemarksList: state.SidePanReducer.RemarksList
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(MDDetail);